export default __webpack_public_path__ + "static/media/search.e8e02f74.png";